import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { withLang } from "./withLang";

export const notificationsApi = createApi({
  reducerPath: "notificationsApi",
  baseQuery: withLang(
    fetchBaseQuery({
      baseUrl: "https://us-central1-scoreholio.cloudfunctions.net/apiv2/",
    }),
  ),
  endpoints: (builder) => ({
    getNotifications: builder.mutation({
      query: (body) => ({
        url: "player/notifications/get",
        method: "POST",
        body: body,
      }),
      transformResponse: (response) => {
        console.log("getNotifications response: ", response);
        try {
          if (response.statusCode === 0) {
            const rows = response.rows || [];

            const notifications = rows.map((row) => {
              return {
                notificationId: row.notificationId || null,
                accountId: row.accountId || null,
                category: row.category || null,
                lastUpdated: row.lastUpdated
                  ? new Date(parseInt(row.lastUpdated) * 1000)
                  : null,
                message: row.message || null,
                userId: row.userId || null,
                status: row.status || null,
                buttons: row.buttons || [],
              };
            });

            return {
              status: response.status,
              notifications,
              total: rows.length || 0,
              hasResults: rows.length > 0,
            };
          } else {
            // Handle different error statuses
            return {
              status: response.statusCode,
              notifications: [],
              total: 0,
              hasResults: false,
              errorMessage: response.statusMessage || "Unknown error",
            };
          }
        } catch (error) {
          console.error("Error transforming notifications response:", error);
          throw error;
        }
      },
    }),
    deleteNotification: builder.mutation({
      query: (body) => ({
        url: "player/notifications/delete",
        method: "POST",
        body: body,
      }),
      transformResponse: (response) => {
        try {
          return {
            status: response.statusCode,
            statusMessage: response.statusMessage,
            success: response.statusCode === 0,
          };
        } catch (error) {
          console.error(
            "Error transforming delete notification response:",
            error,
          );
          throw error;
        }
      },
    }),
  }),
});

export const { useGetNotificationsMutation, useDeleteNotificationMutation } =
  notificationsApi;
